import type { PageContent } from "../types";

export const p_voice_and_conversational_search: PageContent = {
  slug: "voice-and-conversational-search",
  title: `Voice and Conversational Search | Phil Carr SEO Consultant`,
  description: `Voice search continued its steady ascent in 2020, driven by smart speakers and virtual assistants. While adoption rates were not as explosive as some predicted,…`,
  date: "",
  lastUpdated: "2026-04-22",
  body: `# Voice and Conversational Search

![Voice and Conversational Search featured image](/images/blog/generated/voice-and-conversational-search.jpg)

**Published:** June 15, 2020

## Early Growth and Future Potential

Voice search continued its steady ascent in 2020, driven by smart speakers and virtual assistants. While adoption rates were not as explosive as some predicted, voice queries increased as people grew comfortable asking their devices for quick answers, directions and recommendations.

Voice search queries tend to be longer and phrased in natural language, offering opportunities for businesses to capture highly specific intent.

## Optimising for Conversation

To cater to voice queries, focus on long‑tail keywords and conversational phrases. Structure your content so that each section addresses a specific question, using clear headings and concise answers.

Incorporate local descriptors where relevant, such as “near me,” “open now,” or city names. Use schema markup for Q&A and How‑to content to enhance your chances of being pulled into voice results.

Keep your business information up to date across all platforms, as users may ask their devices to call or navigate to your location.

## Practical Advice for Implementation

Create an FAQ page answering common customer questions in straightforward language. Record audio or video content to complement written posts, as multimodal content may become increasingly important.

Monitor how visitors arrive at your site and whether voice search is driving traffic. Use this data to refine your content strategy and identify new opportunities for conversational queries.

## SEO Takeaways and Next Steps

Voice search isn’t just a trend; it’s part of the broader shift towards more natural interactions with technology. If you’re curious how to adapt your site for conversational queries, I can develop a tailored plan. Contact info@phil‑carr.co.uk or 01226 697 325 for assistance.

If you need help with your SEO strategy, get in touch by emailing [info@phil-carr.co.uk](mailto:info@phil-carr.co.uk) or calling 01226 697 325.

## Key Takeaways

- **Early Growth and Future Potential:** Voice search continued its steady ascent in 2020, driven by smart speakers and virtual assistants.
- **Optimising for Conversation:** To cater to voice queries, focus on long‑tail keywords and conversational phrases.
- **Practical Advice for Implementation:** Create an FAQ page answering common customer questions in straightforward language.

## Update — April 2026

Refreshed in April 2026. The E-E-A-T signals Google leans on have become more granular — clear authorship, verifiable experience, and dated updates like this one now carry more visible weight in quality rater feedback than they did a year ago.

## About the author

Phil Carr is an SEO consultant and web strategist focused on helping businesses
grow through technical optimisation, content strategy, and data-driven decision making. His
work combines hands-on experience with ongoing research into algorithm updates and emerging
search trends.

[Read Phil’s bio](/#authorModal)

## Other News Articles

[![2024 Algorithm Updates – Navigating a Year of Core Changes and Spam Crackdowns featured image](/images/blog/generated/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns.jpg)](/blog/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns)

### [2024 Algorithm Updates – Navigating a Year of Core Changes and Spam Crackdowns](/blog/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns)

[![2023 SEO Lessons and Forward View featured image](/images/blog/generated/2023-seo-lessons-and-forward-view.jpg)](/blog/2023-seo-lessons-and-forward-view)

### [2023 SEO Lessons and Forward View](/blog/2023-seo-lessons-and-forward-view)

[![A Practical Plan for AI-Driven Search – A Ninety Day Playbook featured image](/images/blog/generated/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook.jpg)](/blog/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook)

### [A Practical Plan for AI-Driven Search – A Ninety Day Playbook](/blog/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook)

[![Looking Ahead: Lessons from 2024 for the Future featured image](/images/blog/generated/looking-ahead-lessons-from-2024-for-the-future.jpg)](/blog/looking-ahead-lessons-from-2024-for-the-future)

### [Looking Ahead: Lessons from 2024 for the Future](/blog/looking-ahead-lessons-from-2024-for-the-future)

We use cookies to improve your experience, analyse site traffic, and understand how you interact with
our content. Read our [cookie policy](/cookies) to learn more.

Reject optionalAccept cookies [Privacy policy](/privacy-policy)

reCAPTCHA

Recaptcha requires verification.

protected by **reCAPTCHA**`,
};
